<div class="flex justify-between md:flex-1 md:min-h-0 overflow-hidden">
  <div class="relative flex flex-col gap-[1rem] md:block">
    <h1 class="text-vinciBlue-600 pt-[1.75rem] md:pt-[clamp(1rem,8dvh,6.8125rem)]">
      {{ "home.slogan.part1" | transloco }}
      <br />
      {{ "home.slogan.part2" | transloco }}
    </h1>
    <span class="md:absolute md:top-[clamp(0.5rem,7dvh,6.25rem)] md:right-0"
      ><icon
        name="arrow-right-up"
        [color]="'text-vinciBlue-600'"
        size="5rem"
      ></icon
    ></span>
  </div>

  <div class="max-h-[28.75rem] md:max-h-none flex self-end md:self-stretch overflow-visible">
    <img
      [src]="image()"
      alt="Illustration Home"
      class="object-contain object-bottom min-h-[21rem] md:min-h-0 md:max-h-full min-w-[14.9375rem] animate-[slide-in-left_0.8s_ease-out]"
    />
  </div>
</div>

<section
  class="w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] mb-[clamp(0.5rem,3dvh,2.5rem)] flex justify-between mobile-hidden min-h-0"
>
  <div class="flex-1 flex pr-6">
    <div class="flex-1 flex flex-row-reverse bg-white">
      <app-card
        [title]="'home.developmentCard.title' | transloco"
        [text]="'home.developmentCard.text' | transloco"
        [iconName]="'growth'"
        [buttonText]="'home.developmentCard.buttonText' | transloco"
        [buttonVariant]="'secondary'"
        (buttonClick)="cardDevelopmentClick()"
        [extraClass]="
          'flex-1  pl-[max(1.5rem,calc((100vw-78rem)/2+1rem))] max-w-[25rem]'
        "
      />
    </div>

    <app-card
      [title]="'home.mobilityCard.title' | transloco"
      [text]="'home.mobilityCard.text' | transloco"
      [iconName]="'rocket'"
      [buttonText]="'home.mobilityCard.buttonText' | transloco"
      [buttonVariant]="'secondary'"
      (buttonClick)="cardMobilityClick()"
      [extraClass]="'bg-vinciLavender rounded-r-3xl'"
      class="flex-[0_1_25rem]"
    />
  </div>

  <div
    class="flex-1 max-w-[43%] bg-vinciBlue-600 rounded-l-3xl relative overflow-hidden before:absolute before:inset-0 before:bg-[url('/assets/images/bg/bg-texture.svg')] before:opacity-15 before:pointer-events-none before:z-0 animate-[slide-in-left_0.8s_ease-out]"
  >
    <app-card
      [title]="'home.personalizedJourneyCard.title' | transloco"
      [text]="'home.personalizedJourneyCard.text' | transloco"
      [iconName]="'thunder'"
      [buttonText]="'home.personalizedJourneyCard.buttonText' | transloco"
      [buttonVariant]="'primary'"
      [extraClass]="'text-white relative'"
      (buttonClick)="cardJourneyClick()"
    />
  </div>
</section>

<!-- MOBILE VIEW  -->
<div class="flex flex-col gap-5 items-center mb-10 desktop-hidden">
  <div class="rounded-xl flex flex-col w-full">
    <app-card
      [title]="'home.developmentCard.title' | transloco"
      [text]="'home.developmentCard.text' | transloco"
      [iconName]="'growth'"
      [buttonText]="'home.developmentCard.buttonText' | transloco"
      [buttonVariant]="'secondary'"
      (buttonClick)="cardDevelopmentClick()"
      [extraClass]="'bg-white rounded-t-xl'"
    />
    <app-card
      [title]="'home.mobilityCard.title' | transloco"
      [text]="'home.mobilityCard.text' | transloco"
      [iconName]="'rocket'"
      [buttonText]="'home.mobilityCard.buttonText' | transloco"
      [buttonVariant]="'secondary'"
      (buttonClick)="cardMobilityClick()"
      [extraClass]="'bg-vinciLavender rounded-b-xl'"
    />
  </div>

  <app-card
    [title]="'home.personalizedJourneyCard.title' | transloco"
    [text]="'home.personalizedJourneyCard.text' | transloco"
    [iconName]="'thunder'"
    [buttonText]="'home.personalizedJourneyCard.buttonText' | transloco"
    [buttonVariant]="'primary'"
    (buttonClick)="cardJourneyClick()"
    [extraClass]="'text-white relative z-10'"
    class="bg-vinciBlue-600 rounded-xl w-full relative overflow-hidden before:absolute before:inset-0 before:bg-[url('/assets/images/bg/bg-texture.svg')] before:opacity-30 before:pointer-events-none before:z-0"
  />
</div>
